import React from 'react';
import './Connecting.css';

function ConnectingPage() {
    return (<div className={'ConnectingWrapper'}><div>Connecting to Server</div></div>);
}

export default ConnectingPage;